// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"UAx45m","grid":"_1I6fgn","centered-section-spacing":"ByqegQ","grid-odd":"_9s-y6c","boxTextContainer":"P6yfwt","boxTextBox":"cwVdQb","boxTextTitle":"_1WriMy"};